























import { Component, Vue } from 'vue-property-decorator'
import { eventWebservice } from '../webservices/events.webservice'
import { EventModel } from '../models/Event.model'
import VueMarkdown from 'vue-markdown'
import { ContentModel } from '@/models/Content.model'
import { contentWebservice } from '@/webservices/content.webservice'

@Component({
    components: {
        VueMarkdown,
    },
})
export default class Events extends Vue {
    private events: Array<EventModel> = []
    private content: ContentModel = {} as ContentModel

    async mounted() {
        console.log('on mounted')
        await this.loadEvents()
        this.content = await contentWebservice.getContent()
    }

    async loadEvents() {
        this.events = await eventWebservice.getEvents()
    }
}
